module.exports = __webpack_public_path__ + "media/application/images/ui/buttons-twitter-fdb6413f3d0e8e1ed932f8ade6a2b445.png";